module.exports = __webpack_public_path__ + "static/media/6-active.925f108b.svg";